const services = {
  header: {
    create: 'Crear',
  },

  toast: {
    error: {
      badResponse: '[Servicio] respuesta incorrecta del servidor',
      create: {},
      edit: {},
    },
    success: {
      create: {
        body: 'El servicio se ha añadido correctamente',
      },
      delete: {
        body: 'Los servicios se eliminaron correctamente',
      },
      edit: {},
    },
  },
  headerButtons: {
    create: 'Nuevo',
    delete: 'Eliminar',
  },
  table: {
    actions: {
      delete: 'Eliminar',
      export: 'Exportar',
    },
    headers: {
      maxPassengers: 'Máx. Pasajeros',
      sharedWith: 'Compartido con',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },
  create: {
    errorToast: {
      message: 'Ocurrió un error. No se pudo crear el servicio',
    },
    successToast: {
      message: '¡Éxito! Servicio creado correctamente',
    },
  },

  edit: {
    errorToast: {
      message: 'Ocurrió un error. No se pudo actualizar el servicio',
    },
    successToast: {
      message: '¡Éxito! Servicio actualizado correctamente',
    },
  },

  delete: {
    errorToast: {
      message: 'Ocurrió un error. No se pudo eliminar el servicio',
    },
    successToast: {
      message: '¡Éxito! El servicio se eliminó correctamente',
    },
  },

  forms: {
    header: {
      createService: {
        title: 'Crear',
      },

      updateService: {
        title: 'Actualizar',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
      },
    },

    information: {
      details: {
        header: 'Detalles',
        fields: {
          name: 'Nombre',
          type: 'Tipo',
          maxPassengers: 'Máx. Pasajeros',
          shared: 'Compartido con',
          availableCount: 'Número de vehículos',
          penaltyScore: {
            title: 'Puntuación de penalización',
            description: 'Gasto de arrendamiento del vehículo en comparación con la duración extra de la ruta, medido en minutos.',
          },
        },
      },
      actions: {
        header: 'Acciones',
        buttons: {
          delete: 'Eliminar',
          resetPassword: 'Restablecer contraseña',
        },
      },
    },
  },

  serviceTypes: {
    private: 'Privado',
    shared: 'Compartido',
  },
};

export default services;
